var makeSortString = (function() {
    var translate_re = /[āē]/g;
    var translate = {
      "ā": "a",
      "č": "c",
      "ē": "e",
      "ģ": "g",
      "ī": "i",
      "ķ": "k",
      "ņ": "n",
      "š": "s",
      "ū": "u",
      "ž": "z",
    };
    return function(s) {
      return ( s.replace(translate_re, function(match) { 
        return translate[match]; 
      }) );
    }
  })();


// debounce so filtering doesn't happen every millisecond
function debounce( fn, threshold ) {
    var timeout;
    threshold = threshold || 100;
    return function debounced() {
    clearTimeout( timeout );
    var args = arguments;
    var _this = this;
    function delayed() {
        fn.apply( _this, args );
    }
    timeout = setTimeout( delayed, threshold );
    };
}

/**
 * Animated ScrollTo for links
 * @param {object} el 
 * @author richardev
 */
function aScrollTo(el) {
    // ScrollTo all #hashtags with animation
    // Remove links that don't actually link to anything
    el
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 600, function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });
}

/**
 * Convert text to animated rainbow text with gradient
 * @param {object} el 
 */
function rainbowText(el){
    el.each(function(){
        $(this).html(function (i, html) {
            var chars = $.trim(html).split("");
            var newHtml = '';
            var open = 0;
            for (i = 0; i < chars.length; i++) {
                if (chars[i] == '<') open = 1;
                open ? newHtml += chars[i] : newHtml += '<span>' + chars[i] + '</span>';
                if (open && chars[i] == '>') open = 0;
            }
            return newHtml;
        });
    });
}

// Slick Discount Slider (header)
var slickDisc = slickDiscEl = hasSlickDisc = 0;
var slickConfig = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1500,
    centerMode: true,
    centerPadding: "17%",
    infinite: true,
    slidesToShow: 3,
    swipeToSlide: true,
    mobileFirst: true,
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 1087,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 577,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 0,
            settings: {
                slidesToShow: 1
            }
        },
    ]
}
// Links for animated aScrollTo function
var aScrollEl = $('a[href*="#"]');
// All rainbow/animatable text
var rainbowTextEl = $('.rainbow');
var buttonFilters = {};
var buttonFilter;
// quick search regex
var qsRegex, ps;

// Ready P1
$(document).ready(function () {
    // Set rainbox text effect
    rainbowText(rainbowTextEl);
    
    // Init slick
    slickDiscEl = $('#disc-slider');
    slickDisc = slickDiscEl.slick(slickConfig);

    // var scrollCount = null;
    // var scroll= null;
    // slickCompEl.on('wheel', (function(e) {
    //     e.preventDefault();

    //     clearTimeout(scroll);
    //     scroll = setTimeout(function(){scrollCount=0;}, 200);
    //     if(scrollCount) return 0;
    //     scrollCount=1;

    //     if (e.originalEvent.deltaY < 0) {
    //         slickCompEl.slick('slickPrev');
    //     } else {
    //         slickCompEl.slick('slickNext');
    //     }
    // }));

    // Add link scrollTo animation
    aScrollTo(aScrollEl);

    // Dropdown slide animation for BootStrap drop-down
    $('.dropdown').on('show.bs.dropdown', function (e) {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown(150);
    });
    $('.dropdown').on('hide.bs.dropdown', function (e) {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp(150);
    });

    $.ajax({
        type: 'GET', 
        url: 'assets/offers.json',
        dataType: 'json',
        success: function (data) {
            var cats = [];
            var filterCats = '';
            $.each(data, function(i, el) {
                // console.log(el);
                var classes = '';
                var hiddenTxt = '';
                if(el.shop_url){
                    var url = el.shop_url;
                }else{
                    if(el.shop && el.shop.weburl){
                        var url = el.shop.weburl;
                    }else{
                        var url = '#';
                    }
                }

                if (!/^(?:f|ht)tps?\:\/\//.test(url)) url = "http://" + url;
                var img = (el.logo ? el.logo : el.shop.image);

                if(el.categories){
                    var classCats = [];
                    for(i = 0; i < el.categories.length; i++){
                        var slug = makeSortString(el.categories[i].slug.replace(/[-'`~!@#$%^&*()_|+=?;:'"“”,.<>\{\}\[\]\\\/]/gumi, ',').toLowerCase());
                        classes += ' ' + slug;
                        hiddenTxt += ' ' + slug;

                        if(cats.indexOf(slug) == -1){
                            cats.push(slug);
                            filterCats += slug + ',';
                            $('#comp-sort .search-dropdown .dropdown-menu').append('<a class="dropdown-item" href="#" data-filter=".' + slug + '">' + el.categories[i].title + '</a>');
                        }
                    }
                }
                
                var disc = el.discount;
                hiddenTxt += ' ' + disc;

                var txt = el.text;
                hiddenTxt += ' ' + txt;

                if(el.shop){
                    if(el.shop.tags) var tags = el.shop.tags;
                    var name = el.shop.title;
                    hiddenTxt += ' ' + tags + ' ' + name;
                }

                classes = makeSortString(classes.replace(/[-'`~!@#$%^&*()_|+=?;:'"“”,.<>\{\}\[\]\\\/]/gumi, ' ').toLowerCase());
                hiddenTxt = makeSortString(hiddenTxt.replace(/[-'`~!@#$%^&*()_|+=?;:'"“”,.<>\{\}\[\]\\\/]/gumi, ' ').toLowerCase());

                var compHTML = '<div class="col-lg-4 col-md-6 col-xs-12 grid-item' + classes + '" data-category="*"><a href="' + url + '" target="_blank"><div class="box"><img class="logo" src="' + img + '" /><div class="disc"><img class="sticker" src="assets/img/uzlime-v2.png" /><div class="hidden-resizer"><div class="hidden-text">' + hiddenTxt + '</div><h5>' + el.discount + '</h5></div></div><div class="desc">' + el.text + '</div></div></a></div>';
                $('#comp-list .comp-ajax').append(compHTML);
            });

            filterCats = filterCats.replace(/(^,)|(,$)/g, "");

            // init Isotope
            var $compIsotope = $('#comp-list .comp-ajax').isotope({
                itemSelector: '.grid-item',
                isFitWidth: true,
                filter: function() {
                    return qsRegex ? $(this).text().match( qsRegex ) : true;
                }
            });

            // use value of search field to filter
            var $quicksearch = $('#comp-sort input.search').keyup( debounce( function() {
                var val = '(?=.*' + $quicksearch.val().split(/\,|\s/).join(')(?=.*') + ')';
                qsRegex = new RegExp( makeSortString(val.toLowerCase()), 'gmiu' );
                $compIsotope.isotope();
                $("#comp-list").scrollTop( 0 );
                ps.perfectScrollbar('update');
            }, 200 ) );

                // filter items on button click
            $('#comp-sort .search-dropdown .dropdown-menu').on( 'click', '.dropdown-item', function() {
                var filterValue = $(this).attr('data-filter');
                $compIsotope.isotope({ filter: makeSortString(filterValue) });

                var maxScrollHeight = $('.simplebar-content').outerHeight() + 20;
                $('.progress-bar').css('height', $('.simplebar-content').outerHeight() + 20);
                $('#comp-list').scroll(function(){
                    var perc = ps.scrollbarYTop/maxScrollHeight*100;
                    $('.progress-bar .bar').css('height', perc + '%');
                });

                $("#comp-list").scrollTop( 0 );
                ps.perfectScrollbar('update');
            });

            $('#comps .comp-slider-wrap').removeClass('folded');
            $('#search-addon').removeClass('loading');
            ps = new PerfectScrollbar('#comp-list', {
                useBothWheelAxes: false,
                suppressScrollX: true
            });

            
            var resizer = $(".hidden-resizer h5");
            var destHeight = $('#comp-list .box .sticker').outerHeight();

            var minHeight = maxHeight = 0;
            var heighestEl = null;
            var lowestEl = null;
            var $element, $prevElement;

            resizer.each(function(){
                $element = $(this);

                if($prevElement && $element.height() > $prevElement.height()){
                    maxHeight = $element.height();
                    heighestEl = $element; 
                }

                if($prevElement && $element.height() > 0 && $element.height() < $prevElement.height()){
                    minHeight = $element.height();
                    lowestEl = $element; 
                }

                if($prevElement && ($element.height() <= $prevElement.height()) !== true) $element.addClass('resizable');
                
                $prevElement = $(this);
            });

            var size;

            while(heighestEl.height() > minHeight){
                size = parseInt(heighestEl.css("font-size"), 10);
                resizer.css("font-size", size - 3);
            }

            $(".hidden-resizer h5.resizable").css("margin-top", -size - 1);
            
            var maxScrollHeight = $('.simplebar-content').outerHeight() + 20;
            $('.progress-bar').css('height', $('.simplebar-content').outerHeight() + 20);
            $('#comp-list').scroll(function(){
                var perc = ps.scrollbarYTop/maxScrollHeight*100;
                $('.progress-bar .bar').css('height', perc + '%');
            });
        }
    });
});

// Remove preloader when all loaded
$(window).on('load', function () {
    $('#preloader').addClass('fade-out');
    setTimeout(function () {
        $('.let-out-logo').removeClass('fold');

        // Remove preloader fix in case page reloaded too fast on Mozilla
        setTimeout(function () {
            $('#preloader').fadeOut(600, function () {
                $('#preloader').remove();
                $('.let-out-logo').removeClass('fold');
            });
        }, 1000); // Just in case let's
    }, 500);
});